module.exports = __webpack_public_path__ + "img/DE00677.dcab89d6.png";